// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"1d2f9659","824":"7c8cd472","1328":"bf38c298","8275":"ef982479","8394":"bf38c298","8803":"99b614bf","9394":"f1c655e3"}[chunkId] + ".chunk.css";
};